import { useTranslation } from 'react-i18next';

import { PlanSection } from '~/modules/artist-roster/pages/artist-details/pages/media-planner/components/PlanWizard/components/PlanSection';

export function CampaignTypeSection() {
  const { t } = useTranslation('campaign-planner', {
    keyPrefix: 'digitalCampaigns',
  });

  return (
    <PlanSection
      title={t('planWizard.sections.typeOfCampaign.title')}
      description={t('planWizard.sections.typeOfCampaign.description')}
    >
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <p>@TODO WMG1-654 - Type of Campaign</p>
    </PlanSection>
  );
}

CampaignTypeSection.displayName = 'CampaignTypeSection';
